<template>
  <standard-layout title="Admin">
    <v-container fluid>
      <h1>Admin</h1>
    </v-container>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/components/standard-layout.vue";

export default {
  components: {
    StandardLayout
  }
};
</script>
